{
  "title": "Overdra og avslutt andelseierskap",
  "description": "Andelseier ønsker å forlate samvirket, men skal overdra andelseierskapet på én eller flere eiendommer.",
  "propertyAndShareCapital": "Eiendom og andelskapital",
  "propertyAndShareCapitalTitle": "Hvilke eiendommer skal overdras til overtaker?",
  "propertyAndShareCapitalDescription": "Velg hvem som skal overdra hvilke eiendommer",
  "capitalToBeTransferred": "Andelskapital som overdras",
  "remainingPaidCapital": "Gjenværende innbetalt andelskapital",
  "transferAdditionalCapitalTitle": "Overføring av tilleggskapital",
  "transferAdditionalCapitalDescription": "Overføre hele eller deler av tilleggskapitalen",
  "transferAdditionalCapitalLabel": "Ønsker skogeier å overføre hele eller deler av tilleggskapitalen?",
  "ownership": "Eierskap",
  "transferredCapital": "Overdratt kapital",
  "summaryDescription": "Sjekk at informasjonen stemmer før du lagrer og avslutter andelseierskapet",
  "sum": "Sum",
  "allocatedAdditionalCapital": "Tildelt tilleggskapital",
  "totalAdditionalCapital": "Total tilleggskapital",
  "remainingAdditionalCapitalAfterTransfer": "Tilleggskapital som er igjen etter overføring",
  "additionalCapitalToTransfer": "Tilleggskapital til overføring"
}
